import { getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';

const OCPS_RESOURCE_URI = 'https://clients.config.office.net/';

export const getOCPSTokenForBusiness = async (): Promise<string> => {
    const [cachedToken, tokenPromise] = getAccessTokenforResourceAsLazy(OCPS_RESOURCE_URI);

    // If cached token is present, return immediately.
    if (cachedToken) {
        return cachedToken as string;
    }

    // If cachedToken is not present then return the promise which will return the token
    const newToken = await tokenPromise;
    return newToken as string;
};
